// @flow

/* -----------------Type declarations--------------- */
import type { ContentDetails, FolderDetails, FolderItemsCount } from '../types';
import type {
  SelectedItemsMap,
} from '../folder/types';

type Time = {
  hour: number,
  minutes: number,
  isAm: boolean,
};

type HandleScheduleActions = (
type: "removeContent" | "addToSchedule" | "addContent" | "edit" | "delete" | "showInfo" | "goback",
contentId?: ?string,
selectedItems?: ?SelectedItemsMap) => Promise<void>
const todaysTask = {
  noTask: 'noTask',
  complete: 'complete',
  todo: 'todo',
  noSchedule: 'noSchedule',
  goalDateExpired: 'goalDateExpired',
};

type ShortTerm = {
  goalAchievable: boolean,
  optimalStudyDuration: number,
};

type Suggestion = {
  days: number,
  studyDuration: number,
};

type LongTerm = {
  suggestions: Suggestion[],
  requiredDaysToComplete: number,
};

type TodaysTask = $Keys<typeof todaysTask>;

type Content = {
  contentId: ?string,
};

type ScheduleStats = {
  factsMastered: number,
  questionsMastered: number,
};

type CurrentTasks = {
  factsScheduled: number,
  factsCompleted: number,
  factsOverdue: number,
  questionsScheduled: number,
  questionsCompleted: number,
  questionsOverdue: number,
};
type MemoryBreakdown = {
  longTerm: number,
  mediumTerm: number,
  shortTerm: number,
  notAnswered: number,
};
type Schedule = {
  id: string,
  numericId: number,
  name: string,
  isLongTerm: boolean,
  contents: FolderDetails,
  studyDuration: number,
  goalDate: Date,
  reminder: Time,
  created: string,
  updated: string,
  stats: ScheduleStats,
  currentTasks: CurrentTasks,
  memoryBreakdown: MemoryBreakdown,
  isArchived: boolean,
  isCreated: boolean
};

type HandleFinishAction = (
  id: string,
  studyDuration: number,
  t: string,
  goalDate: Date,
  isLongTerm: boolean,
  reminderTime: Time,
  contentIds: string[],
  onBoarding: boolean
) => void
type PartialSchedule = {
  date: Date,
  time?: Time,
  duration?: number,
  created?: Date,
  stats?: ScheduleStats,
  currentTasks: CurrentTasks,
  itemsCount: FolderItemsCount,
  isLongTerm: boolean,
  metadata: *
};

type CreateScheduleState = {
  id?: ?string,
  title: string,
  addedContents: ContentDetails[],
  selectedContents: ContentDetails[],
  goalDate: ?Date,
  isLongTerm: boolean,
  studyDuration: number,
  reminderTime: Time,
  editMode: boolean,
  editContent: boolean,
  showDatePicker: boolean,
  showEditDate: boolean,
  showTimePicker: boolean,
  showEditTime: boolean,
  showLearningModal: boolean,
  showSlider: boolean,
  showDiscardModal: boolean,
  showContentDialog: boolean,
  date: ?string,
  time: ?string,
  query: ?string,
  detailScheduleId: ?string,
  maxStudyDuration: number,
  isArchived: boolean
};

export {
  todaysTask,
};
export type {
  CreateScheduleState,
  Time,
  Content,
  Schedule,
  ShortTerm,
  LongTerm,
  CurrentTasks,
  ScheduleStats,
  TodaysTask,
  MemoryBreakdown,
  PartialSchedule,
  HandleFinishAction,
  HandleScheduleActions,
};
